module.exports = __webpack_public_path__ + "sv.svg?a855cffa55f7df61000f0ee5c27503fc";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sv.svg
// module id = 943
// module chunks = 27